import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, addDoc, updateDoc, doc, query, orderBy } from "firebase/firestore";
import {  where } from "firebase/firestore";

export default function AdminCategories() {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [enabled, setEnabled] = useState(true);
  const [isAntiguaDefault, setIsAntiguaDefault] = useState(true);
  const [usedCategoryIds, setUsedCategoryIds] = useState([]);

  async function load() {
    // Load categories
    const col = collection(db, "categories");
    const q = query(collection(db, "categories"), where("enabled", "==", true));
    const snap = await getDocs(q);
    const list = [];
    for (let i = 0; i < snap.docs.length; i = i + 1) {
      const d = snap.docs[i];
      const item = d.data();
      list.push({ id: d.id, ...item });
    }

    // Also check which categories are used
    const bizSnap = await getDocs(collection(db, "businesses"));
    const used = new Set();
    for (let i = 0; i < bizSnap.docs.length; i++) {
      const b = bizSnap.docs[i].data();
      if (b.categoryIds) {
        b.categoryIds.forEach(c => used.add(c));
      }
    }

    setRows(list);
    setUsedCategoryIds(Array.from(used));
  }

  useEffect(() => { load(); }, []);

  async function createOne() {
    if (!name) return;
    await addDoc(collection(db, "categories"), {
      name, slug, enabled, is_antigua_default: isAntiguaDefault
    });
    setName(""); setSlug("");
    await load();
  }

  async function toggleEnabled(id, curr) {
    const ref = doc(db, "categories", id);
    await updateDoc(ref, { enabled: !curr });
    await load();
  }

  return (
    <div style={{ maxWidth: 800, margin: "20px auto" }}>
      <h2>Categories</h2>
      <div style={{ display: "grid", gap: 8, gridTemplateColumns: "1fr 1fr 1fr 1fr auto" }}>
        <input placeholder="Name" value={name} onChange={(e)=>setName(e.target.value)} />
        <input placeholder="slug" value={slug} onChange={(e)=>setSlug(e.target.value)} />
        <label><input type="checkbox" checked={enabled} onChange={(e)=>setEnabled(e.target.checked)} /> enabled</label>
        <label><input type="checkbox" checked={isAntiguaDefault} onChange={(e)=>setIsAntiguaDefault(e.target.checked)} /> Antigua default</label>
        <button onClick={createOne}>Add</button>
      </div>

      <div style={{ marginTop: 20 }}>
        {(() => {
          const items = [];
          for (let i = 0; i < rows.length; i = i + 1) {
            const r = rows[i];
            if (usedCategoryIds.indexOf(r.id) === -1) continue; // skip unused
            items.push(
              <div key={r.id} style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr auto", gap:8, padding:"8px 0", borderBottom:"1px solid #eee" }}>
                <div>{r.name}</div>
                <div>{r.slug}</div>
                <div>{r.enabled ? "enabled" : "disabled"}</div>
                <div>{r.is_antigua_default ? "Antigua" : "General"}</div>
                <button onClick={()=>toggleEnabled(r.id, r.enabled)}>{r.enabled ? "Disable" : "Enable"}</button>
              </div>
            );
          }
          return items;
        })()}
      </div>
    </div>
  );
}
